import BACK from '../../assets/ClassicDeck/BACK.png'
import CLUB2 from '../../assets/ClassicDeck/CLUB-2.png'
import CLUB3 from '../../assets/ClassicDeck/CLUB-3.png'
import CLUB4 from '../../assets/ClassicDeck/CLUB-4.png'
import CLUB5 from '../../assets/ClassicDeck/CLUB-5.png'
import CLUB6 from '../../assets/ClassicDeck/CLUB-6.png'
import CLUB7 from '../../assets/ClassicDeck/CLUB-7.png'
import CLUB8 from '../../assets/ClassicDeck/CLUB-8.png'
import CLUB9 from '../../assets/ClassicDeck/CLUB-9.png'
import CLUB10 from '../../assets/ClassicDeck/CLUB-10.png'
import CLUBA from '../../assets/ClassicDeck/CLUB-A.png'
import CLUBJ from '../../assets/ClassicDeck/CLUB-J.png'
import CLUBK from '../../assets/ClassicDeck/CLUB-K.png'
import CLUBQ from '../../assets/ClassicDeck/CLUB-Q.png'
import DIAMOND2 from '../../assets/ClassicDeck/DIAMOND-2.png'
import DIAMOND3 from '../../assets/ClassicDeck/DIAMOND-3.png'
import DIAMOND4 from '../../assets/ClassicDeck/DIAMOND-4.png'
import DIAMOND5 from '../../assets/ClassicDeck/DIAMOND-5.png'
import DIAMOND6 from '../../assets/ClassicDeck/DIAMOND-6.png'
import DIAMOND7 from '../../assets/ClassicDeck/DIAMOND-7.png'
import DIAMOND8 from '../../assets/ClassicDeck/DIAMOND-8.png'
import DIAMOND9 from '../../assets/ClassicDeck/DIAMOND-9.png'
import DIAMOND10 from '../../assets/ClassicDeck/DIAMOND-10.png'
import DIAMONDA from '../../assets/ClassicDeck/DIAMOND-A.png'
import DIAMONDJ from '../../assets/ClassicDeck/DIAMOND-J.png'
import DIAMONDK from '../../assets/ClassicDeck/DIAMOND-K.png'
import DIAMONDQ from '../../assets/ClassicDeck/DIAMOND-Q.png'
import HEART2 from '../../assets/ClassicDeck/HEART-2.png'
import HEART3 from '../../assets/ClassicDeck/HEART-3.png'
import HEART4 from '../../assets/ClassicDeck/HEART-4.png'
import HEART5 from '../../assets/ClassicDeck/HEART-5.png'
import HEART6 from '../../assets/ClassicDeck/HEART-6.png'
import HEART7 from '../../assets/ClassicDeck/HEART-7.png'
import HEART8 from '../../assets/ClassicDeck/HEART-8.png'
import HEART9 from '../../assets/ClassicDeck/HEART-9.png'
import HEART10 from '../../assets/ClassicDeck/HEART-10.png'
import HEARTA from '../../assets/ClassicDeck/HEART-A.png'
import HEARTJ from '../../assets/ClassicDeck/HEART-J.png'
import HEARTK from '../../assets/ClassicDeck/HEART-K.png'
import HEARTQ from '../../assets/ClassicDeck/HEART-Q.png'
import SPADE2 from '../../assets/ClassicDeck/SPADE-2.png'
import SPADE3 from '../../assets/ClassicDeck/SPADE-3.png'
import SPADE4 from '../../assets/ClassicDeck/SPADE-4.png'
import SPADE5 from '../../assets/ClassicDeck/SPADE-5.png'
import SPADE6 from '../../assets/ClassicDeck/SPADE-6.png'
import SPADE7 from '../../assets/ClassicDeck/SPADE-7.png'
import SPADE8 from '../../assets/ClassicDeck/SPADE-8.png'
import SPADE9 from '../../assets/ClassicDeck/SPADE-9.png'
import SPADE10 from '../../assets/ClassicDeck/SPADE-10.png'
import SPADEA from '../../assets/ClassicDeck/SPADE-A.png'
import SPADEJ from '../../assets/ClassicDeck/SPADE-J.png'
import SPADEK from '../../assets/ClassicDeck/SPADE-K.png'
import SPADEQ from '../../assets/ClassicDeck/SPADE-Q.png'

export const CLASSICDECK = {
  cards: [
    // CLUB
    {
      name: 'CLUB 2',
      src: CLUB2,
      matchID: 'BLACK2',
    },
    {
      name: 'CLUB 3',
      src: CLUB3,
      matchID: 'BLACK3',
    },
    {
      name: 'CLUB 4',
      src: CLUB4,
      matchID: 'BLACK4',
    },
    {
      name: 'CLUB 5',
      src: CLUB5,
      matchID: 'BLACK5',
    },
    {
      name: 'CLUB 6',
      src: CLUB6,
      matchID: 'BLACK6',
    },
    {
      name: 'CLUB 7',
      src: CLUB7,
      matchID: 'BLACK7',
    },
    {
      name: 'CLUB 8',
      src: CLUB8,
      matchID: 'BLACK8',
    },
    {
      name: 'CLUB 9',
      src: CLUB9,
      matchID: 'BLACK9',
    },
    {
      name: 'CLUB 10',
      src: CLUB10,
      matchID: 'BLACK10',
    },
    {
      name: 'CLUB J',
      src: CLUBJ,
      matchID: 'BLACKJ',
    },
    {
      name: 'CLUB Q',
      src: CLUBQ,
      matchID: 'BLACKQ',
    },
    {
      name: 'CLUB K',
      src: CLUBK,
      matchID: 'BLACKK',
    },
    {
      name: 'CLUB A',
      src: CLUBA,
      matchID: 'BLACKA',
    },
    // SPADE
    {
      name: 'SPADE 2',
      src: SPADE2,
      matchID: 'BLACK2',
    },
    {
      name: 'SPADE 3',
      src: SPADE3,
      matchID: 'BLACK3',
    },
    {
      name: 'SPADE 4',
      src: SPADE4,
      matchID: 'BLACK4',
    },
    {
      name: 'SPADE 5',
      src: SPADE5,
      matchID: 'BLACK5',
    },
    {
      name: 'SPADE 6',
      src: SPADE6,
      matchID: 'BLACK6',
    },
    {
      name: 'SPADE 7',
      src: SPADE7,
      matchID: 'BLACK7',
    },
    {
      name: 'SPADE 8',
      src: SPADE8,
      matchID: 'BLACK8',
    },
    {
      name: 'SPADE 9',
      src: SPADE9,
      matchID: 'BLACK9',
    },
    {
      name: 'SPADE 10',
      src: SPADE10,
      matchID: 'BLACK10',
    },
    {
      name: 'SPADE J',
      src: SPADEJ,
      matchID: 'BLACKJ',
    },
    {
      name: 'SPADE Q',
      src: SPADEQ,
      matchID: 'BLACKQ',
    },
    {
      name: 'SPADE K',
      src: SPADEK,
      matchID: 'BLACKK',
    },
    {
      name: 'SPADE A',
      src: SPADEA,
      matchID: 'BLACKA',
    },
    // DIAMONDS
    {
      name: 'DIAMOND 2',
      src: DIAMOND2,
      matchID: 'RED2',
    },
    {
      name: 'DIAMOND 3',
      src: DIAMOND3,
      matchID: 'RED3',
    },
    {
      name: 'DIAMOND 4',
      src: DIAMOND4,
      matchID: 'RED4',
    },
    {
      name: 'DIAMOND 5',
      src: DIAMOND5,
      matchID: 'RED5',
    },
    {
      name: 'DIAMOND 6',
      src: DIAMOND6,
      matchID: 'RED6',
    },
    {
      name: 'DIAMOND 7',
      src: DIAMOND7,
      matchID: 'RED7',
    },
    {
      name: 'DIAMOND 8',
      src: DIAMOND8,
      matchID: 'RED8',
    },
    {
      name: 'DIAMOND 9',
      src: DIAMOND9,
      matchID: 'RED9',
    },
    {
      name: 'DIAMOND 10',
      src: DIAMOND10,
      matchID: 'RED10',
    },
    {
      name: 'DIAMOND J',
      src: DIAMONDJ,
      matchID: 'REDJ',
    },
    {
      name: 'DIAMOND Q',
      src: DIAMONDQ,
      matchID: 'REDQ',
    },
    {
      name: 'DIAMOND K',
      src: DIAMONDK,
      matchID: 'REDK',
    },
    {
      name: 'DIAMOND A',
      src: DIAMONDA,
      matchID: 'REDA',
    },
    // HEARTS
    {
      name: 'HEART 2',
      src: HEART2,
      matchID: 'RED2',
    },
    {
      name: 'HEART 3',
      src: HEART3,
      matchID: 'RED3',
    },
    {
      name: 'HEART 4',
      src: HEART4,
      matchID: 'RED4',
    },
    {
      name: 'HEART 5',
      src: HEART5,
      matchID: 'RED5',
    },
    {
      name: 'HEART 6',
      src: HEART6,
      matchID: 'RED6',
    },
    {
      name: 'HEART 7',
      src: HEART7,
      matchID: 'RED7',
    },
    {
      name: 'HEART 8',
      src: HEART8,
      matchID: 'RED8',
    },
    {
      name: 'HEART 9',
      src: HEART9,
      matchID: 'RED9',
    },
    {
      name: 'HEART 10',
      src: HEART10,
      matchID: 'RED10',
    },
    {
      name: 'HEART J',
      src: HEARTJ,
      matchID: 'REDJ',
    },
    {
      name: 'HEART Q',
      src: HEARTQ,
      matchID: 'REDQ',
    },
    {
      name: 'HEART K',
      src: HEARTK,
      matchID: 'REDK',
    },
    {
      name: 'HEART A',
      src: HEARTA,
      matchID: 'REDA',
    },
  ],
  cover: {
    name: 'cover',
    src: BACK,
  },
}
